export const TOAST = 9000;
export const MODAL = 10000;



// WEBPACK FOOTER //
// ./src/app/ui/style/common/zindex.js